import { useState, useCallback, useContext } from "react";
import AnimationService from "../../../services/AnimationService";
import UserData from "../../../services/UserData";
import { AnimationErrorMessages, getUserFacingMessage } from "../errors/animationErrors";
import { resolveAnimationGuid } from "../utils";

const useAnimationGeneration = () => {
  const [animationGuid, setAnimationGuid] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userData = useContext(UserData);

  const generateAnimation = useCallback(
    async (options) => {
      try {
        setIsSubmitting(true);
        setIsLoading(true);

        const initialResponse = await AnimationService.generateAnimation(
          userData.jwtToken,
          userData,
          options
        );

        const guid = resolveAnimationGuid(initialResponse);

        if (guid) {
          setAnimationGuid(guid);
          setIsSubmitting(false);
          return initialResponse;
        }
        setIsLoading(false);
        setIsSubmitting(false);
        throw new Error("Invalid response from generateAnimation API");
      } catch (error) {
        setIsLoading(false);
        setIsSubmitting(false);
        return {
          status: "FAIL",
          error: getUserFacingMessage(
            error,
            AnimationErrorMessages.GENERATION_FAILED
          ),
        };
      }
    },
    [userData]
  );

  return {
    generateAnimation,
    animationGuid,
    isLoading,
    setIsLoading,
    isSubmitting,
  };
};

export default useAnimationGeneration;
